export default __webpack_public_path__ + "static/media/discord.6a2dc275.svg";